import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const fetchPayment = () => {
  return apiClient(ENDPOINTS.PAYMENTDETAILS, {
    method: "GET",
  });
};

export const updateReferenceNumber = async (payload) => {
  const response = apiClient(ENDPOINTS.CUSTOMER_PAYMENT.UPDATE_REFERENCE, {
    method: "POST",
    body: payload,
  });
  return response;
};

export const createPaymentPost = (payload) => {
  return apiClient(ENDPOINTS.SAP.PAYMENT_POST, {
    method: "POST",
    body: payload,
    suppressToast: true,
  });
};

export const fetchPaymentForCC = () => {
  return apiClient(ENDPOINTS.CUSTOMER_PAYMENT.SUPERVISOR_HISTORY, {
    method: "GET",
  });
};

// fetchCustomerPaymentReference removed as per refactor

export const submitPaymentRequest = (payload) => {
  return apiClient(ENDPOINTS.CUSTOMER_PAYMENT.SUBMIT, {
    method: "POST",
    body: payload,
  });
};

export const getPaymentHistory = (customerId) => {
  return apiClient(ENDPOINTS.CUSTOMER_PAYMENT.HISTORY(customerId), {
    method: "GET",
  });
};

// Draft Payment Services
export const savePaymentDraft = (payload) => {
  return apiClient(ENDPOINTS.PAYMENT_DRAFT.SAVE, {
    method: "POST",
    body: payload,
  });
};

export const getPaymentDrafts = (userId) => {
  return apiClient(ENDPOINTS.PAYMENT_DRAFT.GET_BY_USER(userId), {
    method: "GET",
  });
};

export const deletePaymentDraft = (id) => {
  return apiClient(ENDPOINTS.PAYMENT_DRAFT.DELETE(id), {
    method: "DELETE",
  });
};
